
export const FETCH_REQUEST: string = 'FETCH_REQUEST';
export const FETCH_SUCCESS: string = 'FETCH_SUCCESS';
export const FETCH_FAILURE: string = 'FETCH_FAILURE';
export const NO_VISIBILITY_RULES: string = 'NO_VISIBILITY_RULES';

export const SET_SUBMITTED: string = 'SET_SUBMITTED';
export const SET_TAB_OPENED: string = 'SET_TAB_OPENED';
export const SET_SETTINGS: string = 'SET_SETTINGS';

export const SET_LOGO_URL: string = 'SET_LOGO_URL';
